import CareerPath2Slider from './CareerPath2Slider'
export default CareerPath2Slider
